module.exports = __webpack_public_path__ + "bfdd8af967b44d4a54da42efa223cdca.png";